module.exports = __webpack_public_path__ + "images/emoji/monkey.46d0da986d7c2e503ea2.png";